import 'core-js/stable';
import './vue';

import './check-city';
import './city-lawyer-select/city-lawyer-select';
import './contact-city-section';
import './contact-form/contact-form';
import './contact-slide-in/contact-slide-in';
import './counselor-grid';
import './counselor-slider';
import './counselor-prompt';
import './gclid';
import './oppref';
import './gutenberg-accordion/accordion';
import './header-city';
import './header-search-toggle';
import './lavendla-tabs';
import './local-contact-info';
import './mobile-menu';
import './quick-navigation';
import './read-more';
import './ReadMore';
import './set-header-height';
import './self-test-analytics';
import './share';
import './sticky-cta-footer';
import './utm-tracking';
import './visitor';

import './tooltip';

// Counselor
import './counselor-profile';
import './single-counselor';
import './verified-by-lavendla';
import './counselor-video';
import './counselor-image';

import './accordion';
import './footer-menu';
import './sidebar';
import './reviews';

// Use to be externally loaded
import './external/bundle-modal';
import './external/city-map';
import './external/city-places-slider';
import './external/memorial-pages-section';
import './external/top-menu-desktop';

// TODO: Check if these are used
import './external/partner-slider';

import Helpers from 'Modules/Helpers.js';
import { initClickTracking } from 'Utils/click-tracking';
import { rememberCtaClick } from './cta-attribution';
import store from './stores/store';

// Remove no-js class
document.querySelector('html').classList.remove('no-js');

initClickTracking();

// Check if text needs to be expandable or not.
document.querySelectorAll('.expandable-text').forEach((text) => {
  const maxHeight = parseInt(getComputedStyle(text).maxHeight, 10);
  let elHeight = 0;

  Array.from(text.children).forEach((child) => {
    let childHeight = child.offsetHeight;
    const style = getComputedStyle(child);

    childHeight += parseInt(style.marginTop) + parseInt(style.marginBottom);
    elHeight += childHeight;
  });

  if (elHeight < maxHeight) {
    text.classList.add('expanded');
    text.parentNode.querySelector('.expandable-text__btn').style.display =
      'none';
  }
});

// Handle click on expandable text link
document.querySelectorAll('.expandable-text__btn').forEach((toggle) => {
  toggle.addEventListener('click', () => {
    const text = toggle.parentNode.querySelector('.expandable-text');

    const addOrRemoveClass = (elem) => {
      elem.classList.contains('expanded')
        ? elem.classList.remove('expanded')
        : elem.classList.add('expanded');
    };

    addOrRemoveClass(toggle);
    addOrRemoveClass(text);
  });
});

// Handle contact form toggle click.
document.addEventListener(
  'click',
  function (e) {
    for (
      let target = e.target;
      target && target !== this;
      target = target.parentNode
    ) {
      if (target.matches('.js-toggle-global-contact-form')) {
        e.preventDefault();
        window.contactFormContent = target.getAttribute(
          'data-contact-form-content'
        );
        const contactButton = document.querySelector(
          '#contact-slide-in > button'
        );
        contactButton.click();

        const location = target.getAttribute('data-location');

        // Remembered before it is reported, not after: the open event reads
        // the call to action back out of the store, so this click has to be in
        // it first.
        rememberCtaClick(location);
        Helpers.gtmContactFormOpenEvent(location);

        break;
      }
    }
  },
  false
);

if (document.body.classList.contains('single-funeral_counselors')) {
  const urlParams = new URLSearchParams(window.location.search);
  const roleParam = urlParams.get('role');

  const updateRole = (role) => {
    switch (role) {
      case 'funeral-advisor':
        store.commit('user/setRole', 'funeral');
        break;
      case 'jurist':
        store.commit('user/setRole', 'law');
        break;
      case 'therapist':
        store.commit('user/setRole', 'therapy');
        break;
    }
  };

  if (roleParam) {
    urlParams.delete('role');
    const newSearch = urlParams.toString() ? `?${urlParams}` : '';
    window.history.replaceState(
      {},
      '',
      `${window.location.pathname}${newSearch}`
    );
    updateRole(roleParam);
  } else {
    const defaultRole = document
      .querySelector('.counselor-top-section')
      .getAttribute('data-default-role');
    updateRole(defaultRole);
  }

  const roleSelect = document.getElementById('roleSelect');
  const roleSelectLabels = document.querySelectorAll(
    '.roles-navigation__label span'
  );
  const roleInfos = document.querySelectorAll('.single-counselor__role-info');
  const paymentForm = document.querySelector('.counselor-payment-form-wrapper');
  const contactForm = document.querySelector('.counselor-contact-form-wrapper');

  if (roleSelect !== null) {
    roleSelect.addEventListener('change', (e) => {
      const selectedOption = e.target.options[e.target.selectedIndex];
      const roleData = selectedOption.value;
      roleSelectLabels.forEach((span) => span.classList.remove('selected'));
      roleInfos.forEach((section) => section.classList.remove('active-role'));

      if (roleData === 'therapist') {
        if (paymentForm !== null) {
          paymentForm?.classList.add('active');
          contactForm?.classList.remove('active');
        } else {
          contactForm?.classList.add('active');
        }
      } else {
        if (paymentForm !== null) {
          paymentForm?.classList.remove('active');
          contactForm?.classList.add('active');
        } else {
          contactForm?.classList.add('active');
        }
      }

      const rolesToUpdate = document.querySelectorAll(
        `.single-counselor__role-info[data-role="${roleData}"]`
      );
      const roleSelectLabelSpanToShow = document.querySelector(
        `.roles-navigation__label > span[data-role="${roleData}"]`
      );
      updateRole(roleData);

      rolesToUpdate.forEach((role) => role.classList.add('active-role'));
      roleSelectLabelSpanToShow.classList.add('selected');
    });
  }

  // If there was a role parameter, set that role as active
  if (roleParam && roleSelect !== null) {
    roleSelect.value = roleParam;
    roleSelect.dispatchEvent(new Event('change'));
  }
}

// Handle error from Facebook Browser in Sentry - Issue LAVENDLA-SE-607/LAVENDLA-DK-1Q1
window._AutofillCallbackHandler =
  window._AutofillCallbackHandler || function () {};
